import { defineAction } from '~/prix'
import publicSafetyAlertReportAction from './alertReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'

const publicSafetyAlertReportDefinition = defineAction({
  ...publicSafetyAlertReportAction,

  input: z.object({
    communityId: z.string().nullish(),
    format: reportFormatSchema,
  }),
  output: z.any(),
})

export default publicSafetyAlertReportDefinition
